import React from "react";
import { ReactController } from "../react_controller";
import { SimpleGrid, CellRenderer } from "@getregistered/greg-editors";
import { Label, Token } from "@primer/react";
import PrimerStyleGuard from "../../components/PrimerStyleGuard";

const renderCell = ({ row, column }) => {
  const rawValue = row[column.key];
  if (typeof rawValue === "object" && rawValue !== null && "cellVariant" in rawValue) {
    const variant = rawValue.cellVariant;
    const text = rawValue.displayValue ?? rawValue.rawValue;
    switch (variant.type) {
      case "badge":
        return <td className={column.cellClass}><Label variant={variant.scheme} size="small">{text}</Label></td>;
      case "token":
        return <td className={column.cellClass}><Token text={String(text)} size="medium" /></td>;
    }
  }
  return <CellRenderer row={row} column={column} />;
};

export class SimpleGridController extends ReactController {
  connect() {
    // SimpleGrid (from greg-editors) does NOT wrap itself in GregPrimerTheme,
    // so the Label/Token cells we render via renderCell are outside any
    // StyleSheetManager. PrimerStyleGuard closes the FOUC gap — see GR-1598.
    this.root.render(
      <PrimerStyleGuard>
        <SimpleGrid {...this.propsValue} renderCell={renderCell} />
      </PrimerStyleGuard>
    );
  }
}
